import { CheckCircleIcon, CircleOffIcon, InfoIcon, TriangleAlertIcon } from 'lucide-react';
import { HTMLAttributes, ReactNode } from 'react';
import { cn } from '../../../helpers';
import { Text } from '../text';

const ICON_MAP = {
  error: CircleOffIcon,
  info: InfoIcon,
  success: CheckCircleIcon,
  warning: TriangleAlertIcon,
};

type AlertBannerProps = HTMLAttributes<HTMLParagraphElement> & {
  children: ReactNode;
  type: 'error' | 'info' | 'success' | 'warning';
};

export const AlertBanner = ({ children, ...rest }: AlertBannerProps) => {
  const Icon = ICON_MAP[rest.type];

  const variants = {
    error: 'bg-red-300',
    info: 'bg-blue-300',
    success: 'bg-green-300',
    warning: 'bg-yellow-300',
  };

  const { type, className, ...otherProps } = rest;

  const customClassName = cn(
    'flex items-center justify-center p-1 gap-2',
    variants[rest.type],
    className
  );

  return (
    <Text as="p" {...otherProps} className={customClassName}>
      <Icon /> {children}
    </Text>
  );
};
